import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  useContext,
} from "react";
import axios from "axios";
import Select from "react-select";
import * as XLSX from "xlsx";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  DATA_EXPORT,
  ERROR_MESSAGE,
} from "../../../common/Constant";
import { Calendar } from "../../../common/imagePath";
import ReactDatetime from "react-datetime";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { AppContext } from "../../../context/AppContext";
import CurrencySymbols from "../../../common/CurrencySymbol";

const AccountsReceivableAgingSummary = (props) => {
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const transactionTypeRef = useRef();
  const selectReportRef = useRef();

  const [dynamicColumnNames, setDynamicColumnNames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [totalbalance, setTotalBalance] = useState(0);
  const [columnby, setcolumnby] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [agingPeriod, setAgingPeriod] = useState(30);
  const [numberPeriod, setNumberPeriod] = useState(4);
  const [dataResponse, setDataResponse] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [saletype, setSaletype] = useState([]);
  const [selectedTransactionType, setSelectedTransactionType] = useState(0);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState(
    []
    // inputValue: "",
    // width: 1,
    // height: 20,
    // fontSize: 15,
    // zeroFill: 10,
  );

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  useEffect(() => {
    transactionTypeRef.current = selectedTransactionType;
  }, [selectedTransactionType]);

  useEffect(() => {
    selectReportRef.current = selectReport;
  }, [selectReport]);

  //Function for downloading pdf of barcodesheet
  const downloadPdf = () => {
    const pdf = new jsPDF();
    responseData.forEach((item) => {
      // Generate barcode for the current item
      const barcodeRef = barcodeRefs.current[item.SaleId];
      const barcodeValue = `${item.SaleId}`;
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        // barcode options
      });

      // Add barcode to PDF
      const canvas = barcodeRef;
      const imgData = canvas.toDataURL("image/png");
      pdf.addImage(imgData, "PNG", 10, 10);
      pdf.addPage();
    });
    pdf.deletePage(responseData.length + 1); // Remove extra page added by addPage() method
    pdf.save("barcodes.pdf");
  };

  //Function for print
  const handlePrint = async () => {
    const pages = document.querySelectorAll("#print");
    const pdf = new jsPDF();

    const input = pages[0];
    const width = input.offsetWidth;
    const height = input.offsetHeight;

    const imgData = await html2canvas(input, { width, height }).then((canvas) =>
      canvas.toDataURL("image/png")
    );

    pdf.addImage(
      imgData,
      "JPEG",
      0,
      0,
      pdf.internal.pageSize.width,
      pdf.internal.pageSize.height
    );

    for (let i = 1; i < pages.length; i++) {
      const input = pages[i];
      const width = input.offsetWidth;
      const height = input.offsetHeight;

      const imgData = await html2canvas(input, { width, height }).then(
        (canvas) => canvas.toDataURL("image/png")
      );

      pdf.addPage();
      pdf.addImage(
        imgData,
        "JPEG",
        0,
        0,
        pdf.internal.pageSize.width,
        pdf.internal.pageSize.height
      );
    }

    // Convert the PDF to a Blob object
    const pdfBlob = pdf.output("blob");

    // Create a URL for the Blob object
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Open a new window with the URL
    const printWindow = window.open(pdfUrl);

    // Wait for the window to load and then print the PDF
    printWindow.addEventListener("load", () => {
      printWindow.print();
    });
  };

  //Function for download
  const handleDownload = async () => {
    const pages = document.querySelectorAll("#print");
    const pdf = new jsPDF();

    const input = pages[0];
    const width = input.offsetWidth;
    const height = input.offsetHeight;

    const imgData = await html2canvas(input, { width, height }).then((canvas) =>
      canvas.toDataURL("image/png")
    );

    pdf.addImage(
      imgData,
      "JPEG",
      0,
      0,
      pdf.internal.pageSize.width,
      pdf.internal.pageSize.height
    );

    for (let i = 1; i < pages.length; i++) {
      const input = pages[i];
      const width = input.offsetWidth;
      const height = input.offsetHeight;

      const imgData = await html2canvas(input, { width, height }).then(
        (canvas) => canvas.toDataURL("image/png")
      );

      pdf.addPage();
      pdf.addImage(
        imgData,
        "JPEG",
        0,
        0,
        pdf.internal.pageSize.width,
        pdf.internal.pageSize.height
      );
    }

    pdf.save("document.pdf");
  };

  const handleDropdownChange = (event) => {
    // const selectedValue = event.target.value;
    setSelectReport(event?.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const renderAccordionIcon = (index) => {
    if (activeAccordion === index) {
      return <FontAwesomeIcon icon={faChevronUp} />;
    } else {
      return <FontAwesomeIcon icon={faChevronDown} />;
    }
  };

  console.log("11cccc", responseData);
  //Function for lookup receipt
  const paramObject = useParams();
  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/receivableagingsummary?startdate=${startdate}&enddate=${enddate}&daysperagingperiod=${agingPeriod}&numberofperiods=${numberPeriod}&locationid=${locationid}&selectedTransactionType=${selectedTransactionType}&selectReport=${selectReport}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(
            res.data.ResponseData.PeriodswithCustomerbalancedetail
          );
          setDynamicColumnNames(res.data.ResponseData.Periods);
          // setData(res.data.ResponseData.respose);
          // setDataResponse(res.data.ResponseData.Periods);
          // setCustomer(res.data.ResponseData.CustomerDetails);

          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   if (
  //     (agingPeriod === undefined || agingPeriod === "") &&
  //     (numberPeriod === undefined || numberPeriod === "")
  //   ) {
  //     toastError("Days per aging period or Number of periods can't be empty");
  //     return;
  //   } else if (agingPeriod === undefined || agingPeriod === "") {
  //     toastError("Please enter a number between 1 to 500");
  //     return;
  //   } else if (numberPeriod === undefined || numberPeriod === "") {
  //     toastError("Please enter a number between 1 to 50");
  //     return;
  //   } else {
  //     apicall();
  //   }
  // }, [startdate, enddate, agingPeriod, numberPeriod]);

  console.log(dynamicColumnNames, "dynamicColumnNames");
  const respose = [...dataResponse, ...responseData, ...customer];
  console.log("xyz=====>", respose);
  useEffect(() => {
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);
    // setLoading(true);

    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/getalltransactiontype?isshowviewregister=3`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const transactionType = res.data.ResponseData.map((u) => ({
          label: u.Name,
          value: u.ID,
        }));
        setSaletype(transactionType);
        console.log("res280", res.data.ResponseData);
      });
  }, []);

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Amount);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  const calculateTotalbalance = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.OpenBalance);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);
    setTotalBalance(sum);
  };

  useEffect(() => {
    calculateTotalSum();
    calculateTotalbalance();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };
  const [openBalance, setOpenBalance] = useState([]);

  // const columnDefs = Object.keys(respose).map((Period, index) => {
  //   return {
  //       headerName: respose[index].Period,
  //       field:Period
  //     ,
  //   };

  // });

  const dynamicColumn = dynamicColumnNames.map((el) => ({
    header: `${el?.AgingPeriod}`,
    accessorKey: `${el?.AgingPeriod}`,
    Cell: ({ row }) => {
      const subamount = row?.original?.[el?.AgingPeriod]; // Access value dynamically

      return (
        <div>
          {CurrencySymbols(
            Number(subamount),
            { CurrencySymbol },
            FractionDigits
          )}
        </div>
      );
    },
  }));
  console.log("CustomerId1", selectedTransactionType, selectReport);

  const handleOpenReport = (
    CustomerId,
    start,
    end,
    transactionType,
    report
  ) => {
    const url = `/accounts-receivable-aging-detail?custid=${CustomerId}&startdate=${start}&enddate=${end}&selectedTransactionType=${transactionType}&selectReport=${report}`;
    window.open(url, "_blank");
  };

  const columns = useMemo(
    () => [
      {
        header: "Customer",
        accessorKey: "Customer",
      },
      // Includes the dynamic columns after Customer
      {
        header: "Total",
        accessorKey: "Total",
        size: "120",
        Cell: ({ row }) => (
          <Box
            component="span"
            sx={{
              borderRadius: "0.3rem",
              color: "#343f62",
              maxWidth: "18ch",
              textDecoration: "underline",
              textUnderlineOffset: "3px",
              p: "0.3rem",
              cursor: "pointer",
              display: "flex",
              textAlign: "end",
              alignItems: "center",
              fontWeight: "700",
            }}
            onClick={() => {
              handleOpenReport(
                row.original.CustomerId,
                startdate,
                enddate,
                transactionTypeRef.current,
                selectReportRef.current
              );
            }}
            // onClick={() =>
            //   window.open(
            //     `/accounts-receivable-aging-detail?custid=${row.original.CustomerId}&startdate=${startdate}&enddate=${enddate}&selectedTransactionType=${selectedTransactionType}&selectReport=${selectReport}`,
            //     "_blank"
            //   )
            // }
          >
            {CurrencySymbols(
              Number(row.original.Total),
              { CurrencySymbol },
              FractionDigits
            )}
          </Box>
        ),
      },
    ],
    []
  ); // Ensure to update if dynamicColumn changes

  const mixedColumns = [columns[0], ...dynamicColumn, columns[1]];

  console.log(columns, "columns");
  console.log(dynamicColumn, "dynamicColumn");
  console.log(mixedColumns, "mixedColumns");

  const columnDefs = Object.keys(respose).map((Period, index) => {
    return {
      headerName: respose[index].Period,
      field: Period,
      valueGetter: function (params) {
        return respose[index][params.colDef.field];
      },
    };
  });

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const defaultColDef = {
    sortable: true,
  };
  const autoGroupColumnDef = {
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      var res = valueA == valueB ? 0 : valueA > valueB ? 1 : -1;
      return res;
    },
    field: "athlete",
    sort: "asc",
  };

  // const onGridReady = useCallback((params) => {
  //   setLoading(true);

  //   axios
  //     .get(
  //       `${
  //         config.reportsBaseUrl
  //       }/reports/receivableagingsummary?startdate=${""}&enddate=${""}&daysperagingperiod=${""}&numberofperiods=${""}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("res======>", res);
  //       console.log(res.data.ResponseData);
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         setResponseData(
  //           res.data.ResponseData.PeriodswithCustomerbalancedetail
  //         );
  //         setData(res.data.ResponseData.PeriodswithCustomerbalancedetail);
  //         // setOpenBalance(res.data.ResponseData.OpenBalance);
  //       }
  //       data.Amount = parseInt(data.Amount, 10);
  //       data.OpenBalance = parseInt(data.OpenBalance, 10); // Convert to integer

  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setLoading(false);
  //     });
  // }, []);

  // useEffect(() => {
  //   onGridReady();
  // }, [onGridReady]);

  const totalFooterRow = {
    Period: "Total",
    Amount: totalSum,
    OpenBalance: totalbalance,
  };

  const augmentedData = [...respose, totalFooterRow];

  //   const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Open Purchase Order List</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Accounts Receivable Aging Summary
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              {/* <div className="row"> */}
              {/* <div className="col-md-4 z-3"> */}
              <label className="col-form-label form-label p-lg-medium">
                Report period
              </label>
              <Select
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                options={reportdropdown}
                // defaultValue={selectReport}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                hideSelectedOptions={true}
                // isClearable={true}
                name="Reportperiod"
                id="Reportperiod"
                value={reportdropdown.find((e) => e.value === selectReport)}
                onChange={(event) => {
                  handleDropdownChange(event);
                }}
                className="custom-search-select"
              ></Select>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 1 ||
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-2 ">
              <label className="col-form-label form-label">
                Days per aging period
              </label>
              <input
                className="form-control"
                name="agingperiod"
                id="agingperiod"
                value={agingPeriod}
                onChange={(e) => {
                  setAgingPeriod(e.target.value);
                }}
              ></input>
            </div>
            <div className="col-sm-2 ">
              <label className="col-form-label form-label">
                Number of periods
              </label>
              <input
                className="form-control"
                name="numberperiod"
                id="numberperiod"
                value={numberPeriod}
                onChange={(e) => {
                  setNumberPeriod(e.target.value);
                }}
              ></input>
            </div>
            <div className="col-sm-3">
              <label className="col-form-label form-label p-lg-medium">
                Transaction Type
              </label>
              <Select
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                options={saletype}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                hideSelectedOptions={true}
                isClearable={true}
                onChange={(event) =>
                  setSelectedTransactionType(event ? event.value : 0)
                }
                value={
                  saletype.find((e) => e.value === selectedTransactionType) || 0
                }
                className="custom-search-select"
              />
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>

          {/* Receipt */}
          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 className="p">SonarPos</h6>
                    <p className="fw-bold p-regular">
                      {" "}
                      Accounts Receivable Aging Summary
                    </p>
                    <div className="row mb-2">
                      {/* <h6> Date: {new Date().toLocaleDateString()}</h6> */}
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />

                {/* <div className="table-responsive">
                <div
                  className="ag-theme-alpine"
                  style={{ height: "100vh", width: "100%" }}
                >
                  <AgGridReact
                    rowData={augmentedData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    autoGroupColumnDef={autoGroupColumnDef}
                    onGridReady={onGridReady}
                  ></AgGridReact>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 text-center">
                  <p>
                    {" "}
                    {currentDate.toLocaleString()} &nbsp;GMT Time: {hours}:
                    {minutes}
                  </p>
                </div>
              </div> */}
                <div>
                  <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Accounts Receivable Aging Summary"
                    columns={mixedColumns}
                    data={responseData}
                    startdate={startdate}
                    enddate={enddate}
                    enableRowSelection={false}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AccountsReceivableAgingSummary;
